import { ENV } from 'config';
import { useTranslation } from 'react-i18next';

import NavigationExternalLink from './NavigationExternalLink';

export default function LinkToPrivacy() {
    const { t } = useTranslation('navigation');

    return (
        <NavigationExternalLink
            url={ ENV.PRIVACY_LINK }
            label={ t('navigationItem.privacy') }
        />
    );
}
